<template>
  <div class="relative filters">
    <filter-slide-out
      :left-title="leftTitle"
      :left-options="leftOptions"
      :left-options-interpolation="leftOptionsInterpolation"
      :right-title="rightTitle"
      :right-options="rightOptions"
      :prop-selected-color="selectedFilters.color"
      :prop-selected-scale="selectedFilters.scale"
    />
    <filter-button
      :selected-color="selectedFilters.color.option"
      :count="count"
      :loading="loading"
    />
  </div>
</template>

<script>
import FilterButton from './FilterButton.vue';
import FilterSlideOut from './FilterSlideOut.vue';

export default {
  components: {
    FilterButton,
    FilterSlideOut,
  },
  props: [
    'leftTitle',
    'leftOptions',
    'leftOptionsInterpolation',
    'rightTitle',
    'rightOptions',
    'selectedFilters',
    'count',
    'loading',
  ],
};
</script>
